import { getRequiredFields } from 'utils/form'
import constants from 'constants'

const fields = [
  {
    label: 'From account',
    name: 'fromAccount',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: true,
    options: [],
    searchable: true,
    validators: [
      {
        check: 'required',
      },
    ],
    error: 'Please select from account',
  },
  {
    label: 'To account',
    name: 'toAccount',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: true,
    options: [],
    searchable: true,
    validators: [
      {
        check: 'required',
      },
    ],
    error: 'Please select to account',
  },
  {
    label: 'Payee',
    name: 'payee',
    layout: 'fullWidth',
    maxLength: 20,
    validators: [
      {
        check: 'requiredIf',
        fields: 'payee|toAccount',
        error: 'Please enter a payee',
        conditions: constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.CHEQUE,
      },
    ],
  },
  {
    label: 'Account',
    name: 'account',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: true,
    options: [],
    searchable: true,
    validators: [
      {
        check: 'requiredIf',
        fields: 'account|toAccount',
        error: 'Please enter a payee',
        conditions: constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.INTERNAL,
      },
    ],
  },
  {
    label: 'ATO Payment Reference Number',
    name: 'atoEftCodeNo',
    layout: 'fullWidth',
    maxLength: 20,
    validators: [
      {
        check: 'requiredIf',
        fields: 'atoEftCodeNo|toAccount',
        error: 'Please enter a ATO Payment Reference Number',
        conditions: constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.ATO,
      },
    ],
  },
  {
    label: 'PAYG Notice - NAME',
    name: 'paygNoticeName',
    layout: 'fullWidth',
    maxLength: 50,
    validators: [
      {
        check: 'requiredIf',
        fields: 'paygNoticeName|toAccount',
        error: 'Please enter a PAYG notice name',
        conditions: constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.ATO,
      },
    ],
  },
  {
    label: 'To Account Name',
    name: 'toAccountName',
    layout: 'fullWidth',
    maxLength: 50,
    validators: [
      {
        check: 'requiredIf',
        fields: 'toAccountName|toAccount',
        error: 'Please enter account name',
        conditions: constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.OVERSEAS,
      },
    ],
  },
  {
    label: 'To Account Number',
    name: 'toAccountNumber',
    layout: 'fullWidth',
    maxLength: 50,
    validators: [
      {
        check: 'isAccountNumberIf',
        fields: 'toAccountNumber|toAccount',
        error: 'Please enter a valid account number',
        conditions: constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.BANK,
      },
      {
        check: 'requiredIf',
        fields: 'toAccountNumber|toAccount',
        error: 'Please enter account number',
        conditions: constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.OVERSEAS,
      },
    ],
  },
  {
    label: 'Bank name',
    name: 'bankName',
    layout: 'fullWidth',
    maxLength: 50,
    validators: [
      {
        check: 'requiredIf',
        fields: 'bankName|toAccount',
        error: 'Please enter a bank code',
        conditions: constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.OVERSEAS,
      },
    ],
  },
  {
    label: 'Bank code',
    name: 'bankCode',
    layout: 'fullWidth',
    maxLength: 50,
  },
  {
    label: 'BSB',
    name: 'bankBSB',
    layout: 'fullWidth',
    maxLength: 6,
    validators: [
      {
        check: 'requiredIf',
        fields: 'bankBSB|toAccount',
        error: 'Please enter a valid account BSB no',
        conditions: constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.BANK,
      },
      {
        check: 'isBSB',
        error: 'Please enter a valid account BSB no',
      },
    ],
  },
  {
    label: 'Bank address',
    name: 'bankAddress',
    layout: 'fullWidth',
    maxLength: 50,
  },
  {
    label: 'Bank city',
    name: 'bankCity',
    layout: 'fullWidth',
    maxLength: 50,
    validators: [
      {
        check: 'requiredIf',
        fields: 'bankCity|toAccount',
        error: 'Please enter a bank city',
        conditions: constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.OVERSEAS,
      },
    ],
  },
  {
    label: 'Bank state',
    name: 'bankState',
    layout: 'fullWidth',
    maxLength: 50,
  },
  {
    label: 'Bank country',
    name: 'bankCountry',
    layout: 'fullWidth',
    maxLength: 50,
    validators: [
      {
        check: 'requiredIf',
        fields: 'bankCountry|toAccount',
        error: 'Please enter a bank country',
        conditions: constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.OVERSEAS,
      },
    ],
  },
  {
    label: 'ZIP',
    name: 'bankZip',
    layout: 'fullWidth',
    maxLength: 50,
  },
  {
    label: 'Amount',
    name: 'amount',
    layout: 'fullWidth',
    maxLength: 50,
    validators: [
      {
        check: 'requiredNumber',
        error: 'Please enter the amount to transfer',
      },
      {
        check: 'isAmountOverdrawn',
        fields: 'amount|amountFrom',
        error: 'This transfer will overdraw your account. Please contact National Partner Services at partnerservices@deloitte.com.au to request authorisation for the transfer',
      },
    ],
  },
  {
    label: '',
    name: 'amountFrom',
    layout: 'fullWidth',
    maxLength: 50,
  },
]

export const requiredFields = getRequiredFields(fields)
export const formFields = fields
export default formFields



// WEBPACK FOOTER //
// ./src/schemas/forms/BankTransferForm.js